import React, { useEffect, useRef, useState } from 'react'

import DataTableList from '../../components/DataTable/DataTableList'
import NoResults from '../../components/Noresults';
import { DateInRange } from '../../utils/dateRange';
import Dropdown from '../../components/Dropdown/Dropdown';
import { formattedDate } from '../../utils/formattedDate';

import search from '../../assets/images/search.svg';
import avatar from '../../assets/images/Avatar.png'
import CustomDatePicker from '../../components/CustomDatePicker';
import { PAYMENT_PLAN, PAYMENT_STATUS, USER_MEMBER, USER_PAYMENT_TYPE } from '../../constants/common';

const TransactionList = (props) => {
    const { userEditRef, setEditTransaction, transactionList, setSelectedTransaction, isLoading, setIsLoading, currentPage, totalPage, setCurrentPage, isLoadingData, setIsLoadingData, searchQuery, setSearchQuery, filterTransaction, setFilterTransaction } = props
    const userPlanRef = useRef();
    const userTypeRef = useRef();
    const selectAmountRef = useRef()
    const selectDateRef = useRef()
    const selectStatusRef = useRef()

    const userUniversity = USER_MEMBER;
    const paymentType = USER_PAYMENT_TYPE;
    const userPlan = PAYMENT_PLAN;
    const paymentStatus = PAYMENT_STATUS;

    const [statusSelect, setStatusSelect] = useState(false)
    const [selectAmount, setSelectAmount] = useState(false)
    const [selectDate, setSelectDate] = useState(false)
    const [planSelect, setPlanSelect] = useState(false)
    const [userTypeSelect, setUserTypeSelect] = useState(false)
    const [columnWidths, setColumnWidths] = useState([]);
    const [selectedTypes, setSelectedTypes] = useState([]);
    const [selectedAmount, setSelectedAmount] = useState([]);

    useEffect(() => {
        if (transactionList?.length > 0) {
            calculateColumnWidths().then(() => {
                setTimeout(() => {
                    setIsLoadingData(false);
                }, 1000);
            });
        }
    }, [transactionList]);

    const calculateColumnWidths = () => {
        return new Promise((resolve) => {
            const tempWidths = transactionList?.reduce((acc, row) => {
                Object?.keys(row)?.forEach((key) => {
                    const dataValue = row[key]?.toString();
                    const title = row[key];

                    let maxContentLength = 0;

                    maxContentLength = Math?.max(dataValue?.length, title?.length);

                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});
            if (tempWidths !== undefined) {
                const widthMap = Object?.keys(tempWidths)?.reduce((acc, key) => {
                    acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    return acc;
                }, {});

                setColumnWidths(widthMap);
            }
            resolve();
        });

    };
    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '24px',
                color: '#666666'
            },
        },
    };

    const columns = [
        {
            name: 'Number',
            selector: (row) => row?.id,
            cell: (row) => {
                return <span className="">
                    #{row?.id || 'NO NAME'}
                </span>
            },
            sortable: true,
            width: '180px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px', width: '180px', }
        },
        {
            name: 'User',
            selector: (row) => row?.userName,
            cell: (row) => {
                return <div className="transaction-content transactionTable" onClick={() => { setEditTransaction(true); setSelectedTransaction(row); }}>
                    <img src={row?.userPic || avatar} />
                    <div className="transaction-brief">
                        <span className="transaction-name">
                            {row?.userName || 'NO NAME'}
                        </span>
                    </div>
                </div>
            },
            sortable: true,
            minWidth: columnWidths['userName'] && `${parseInt(columnWidths['userName']) + 95}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 500, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Type',
            selector: (row) => row?.userType,
            cell: (row) => {
                const matched = paymentType?.find((user) => user?.key === row?.userType);
                return (
                    <span className={`transaction-type ${matched?.value}`}>
                        {matched ? matched?.value : "NO NAME"}
                    </span>
                );
            },
            sortable: true,
            width: columnWidths['userType'] && `${parseInt(columnWidths['userType']) + 160}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", },
        },
        {
            name: 'Plan',
            selector: (row) => row?.plan,
            cell: (row) => {
                const matched = userPlan?.find((plan) => plan?.key === row?.plan);
                return (
                    row?.plan?.trim() ? (
                        <span className='transaction-plan'>{matched?.value}</span>
                    ) : null
                )
            },
            paddingLeft: 0,
            sortable: true,
            width: columnWidths['plan'] && `${parseInt(columnWidths['plan']) + 110}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", width: columnWidths['plan'] && `${parseInt(columnWidths['plan']) - 20}px`, lineHeight: '20px' },
        },
        {
            name: 'Amount',
            selector: (row) => row?.amount,
            cell: (row) => {
                return (
                    <div>
                        <span>${row?.amount}</span>
                    </div>
                )
            },
            paddingLeft: 0,
            sortable: true,
            width: columnWidths['amount'] && `${parseInt(columnWidths['amount']) - 55}px`,
            minWidth: "200px",
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Date',
            selector: (row) => row?.date,
            cell: (row) => {
                return <p>{formattedDate(row?.date)}</p>
            },
            sortable: true,
            width: columnWidths['date'] && `${parseInt(columnWidths['date']) - 50}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontSize: "14px", color: '#05171A', fontWeight: 400, lineHeight: '20px', letterSpacing: '-0.28px' },
        },
        {
            name: 'Status',
            selector: (row) => row?.status,
            cell: (row) => {
                const matched = paymentStatus?.find((status) => status?.key === row?.status);
                return <p className={`transaction-status ${matched?.value}`}>{matched?.value}</p>
            },
            sortable: true,
            width: columnWidths['status'] && `${parseInt(columnWidths['status']) + 30}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px" },
        },
        {
            name: 'Actions',
            cell: (row) => {
                return (
                    <>
                        <div className='table-actions'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" onClick={() => { setEditTransaction(true); setSelectedTransaction(row) }}>
                                <path d="M2.15703 13.583C2.19149 13.2729 2.20872 13.1179 2.25564 12.9729C2.29726 12.8444 2.35607 12.722 2.43048 12.6092C2.51434 12.482 2.62466 12.3717 2.8453 12.151L12.75 2.24632C13.5784 1.41789 14.9216 1.41789 15.75 2.24632C16.5784 3.07475 16.5784 4.41789 15.75 5.24632L5.84529 15.151C5.62466 15.3717 5.51434 15.482 5.38717 15.5658C5.27434 15.6402 5.15197 15.6991 5.02338 15.7407C4.87845 15.7876 4.72339 15.8048 4.41328 15.8393L1.875 16.1213L2.15703 13.583Z" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </>
                )
            },
            justifyContent: 'flex-end',
            allowOverflow: true,
            button: true,
            minWidth: "55px",
            paddingRight: '16px',
            width: '70px',
            style: { textAlign: 'right', minWidth: '70px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px" },
        },
    ]

    return (
        <div className='active-transaction'>
            <div className='active-transaction-top'>
                <div className='pagesSearch twoItemWrap'>
                    <div className="pageSearchInput">
                        <input type="text" name="pages_search" className="inputFields" id="pages_search" placeholder={'Search transactions...'} autoComplete="off" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                        <img src={search} alt="Search" />
                    </div>

                    <Dropdown
                        ref={userTypeRef}
                        selectedDropdown={userTypeSelect}
                        setSelectedDropdown={setUserTypeSelect}
                        items={paymentType}
                        setSelectedValue={(val) => {
                            setFilterTransaction(prev => ({
                                ...prev,
                                userType: val
                            }));
                        }}
                        selectedValue={filterTransaction?.userType}
                        name={"Type"}
                    />

                    <Dropdown
                        ref={userPlanRef}
                        selectedDropdown={planSelect}
                        setSelectedDropdown={setPlanSelect}
                        items={userPlan}
                        setSelectedValue={(val) => {
                            setFilterTransaction(prev => ({
                                ...prev,
                                plan: val
                            }));
                        }}
                        selectedValue={filterTransaction?.plan}
                        name={"Plan"}
                    />

                    <Dropdown
                        ref={selectAmountRef}
                        selectedDropdown={selectAmount}
                        setSelectedDropdown={setSelectAmount}
                        items={userUniversity}
                        setSelectedValue={setSelectedAmount}
                        selectedValue={selectedAmount}
                        name={"Amount"}
                    />

                    <CustomDatePicker
                        onApply={(dateRange) => {
                            setFilterTransaction(prev => ({
                                ...prev,
                                date: dateRange
                            }));
                            setSelectDate(false);
                        }}
                        selectedDate={filterTransaction?.date}
                        onCancel={() => setSelectDate(false)}
                        isSelectDate={selectDate}
                        ref={selectDateRef}
                        setSelectDate={setSelectDate}
                        label={"Date"}
                    />

                    <Dropdown
                        ref={selectStatusRef}
                        selectedDropdown={statusSelect}
                        setSelectedDropdown={setStatusSelect}
                        items={paymentStatus}
                        setSelectedValue={(val) => {
                            setFilterTransaction(prev => ({
                                ...prev,
                                status: val
                            }));
                        }}
                        selectedValue={filterTransaction?.status}
                        name={"Status"}
                    />

                </div>
            </div>
            <div className='table-pagination-wrapper transaction-list'>
                <div className={`pagesTable dataTable-list ${isLoadingData ? 'loading-list' : ''}`}>
                    <DataTableList
                        data={transactionList}
                        columns={columns}
                        customStyles={customStyles}
                        onChangePage={setCurrentPage}
                        paginationTotalRows={totalPage}
                        currentPage={currentPage}
                        pagination={false}
                        progressPending={isLoading}
                        progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                        noDataComponent={<NoResults title='No transactions yet' description="Looks like there aren’t any transactions to show right now. Keep an eye out - new money is joining all the time!" />}
                    />
                </div>
            </div>
        </div>
    )
}

export default TransactionList